import React from 'react';
import style from './mainSearch.module.scss';
import Typography from '@mui/material/Typography';
import cx from 'classnames';
import GeneralSearch from 'controls/search/generalSearch/generalSearch';

export default function MainSearch(props: { text: string }) {
  return (
    <div className={cx(style.container, 'adaptive-mainSearch__container')}>
      <div className={style.relative}>
        <Typography className={cx(style.text, 'adaptive-mainSearch__text')}>
          {props.text}
        </Typography>

        <div className={cx(style.searchWrapper, 'adaptive-search__container')}>
          <GeneralSearch></GeneralSearch>
        </div>
      </div>
    </div>
  );
}
